import React, {FC, useMemo} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {Price} from 'components/price/price';
import {CART_UPGRADE_UPGRADE_INSURANCE_LEARN_MORE_USAGE_MODAL} from 'constants/analytics/events/cartUpgrade';

import {InsurancePopupConnected} from '../insurancePopup/insurancePopup';
import {CoverageUpsellType} from '../upsells/upsells';

export type PropsType = {
    props: CoverageUpsellType;
    closeModal: () => void;
};

/**
 * Insurance modal on cart page
 * @param {PropsType} - PropsType
 * @return {React.ReactElement} - Insurance modal
 */
export const InsuranceCartModal: FC<PropsType> = ({closeModal, props}) => {
    const memoizedButtons = useMemo(() => {
        if (props.isAdded) return [];
        return [
            {
                isAdded: props.isAdded,
                key: props.title,
                label: (
                    <>
                        {props.title.toLowerCase().includes('1-year')
                            ? '1-year coverage'
                            : '2-year coverage'}
                        <span>
                            &nbsp;(<Price>{props.price}</Price>)
                        </span>
                    </>
                ),
                onClick: (buttonLocation: 'Top' | 'Bottom') => {
                    props.toggleUpsell();
                    sendDesktopAnalyticsEvent(
                        CART_UPGRADE_UPGRADE_INSURANCE_LEARN_MORE_USAGE_MODAL,
                        {
                            label: props.title.toLowerCase().includes('1-year')
                                ? `1-year insurance - Add - PopUp ${buttonLocation}`
                                : `2-year insurance - Add - PopUp ${buttonLocation}`,
                        },
                    );
                },
            },
        ];
    }, [props.title, props.price, props.toggleUpsell, props.title, props.isAdded]);
    return (
        <>
            <InsurancePopupConnected
                buttons={memoizedButtons}
                closePopup={closeModal}
                itemId={props.itemId}
            />
        </>
    );
};
